import React from "react";
import '../../SuccessIcon/SuccessIcon.css';
import greenCheck from '../../../../assets/icons/icon-success.svg';
import orangeAsterisk from '../../../../assets/icons/orange-asterisk.svg';
import { useWidth } from "../../../../hooks/useWidth";

interface ISuccessIconProps {
    showIcon: boolean;
    error?: boolean;
}

const SuccessIconOrangeVariant = ({ showIcon, error }: ISuccessIconProps) => {
    const width = useWidth();

    return (
        <div className={`SuccessIcon__successIconContainer ${error ? '!mt-0': ''}`}>
        { width > 768 && <img className={showIcon ? '' : 'SuccessIcon__iconSuccess--hidden'} src={greenCheck} alt={'success icon'} />}
        { width <= 768 && <img src={showIcon ? greenCheck : orangeAsterisk} alt={`${showIcon ? 'success': 'required'} icon`}/>}
    </div>
    )
}
export default SuccessIconOrangeVariant;